// Stack Scroll Custom Cursor Script
(function() {
  'use strict';
  
  // Check if device supports hover
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
    return;
  }

  // Global cursor instance
  let globalCursor = null;

  class StackScrollCursor {
    constructor() {
      this.cursor = null;
      this.currentX = 0;
      this.currentY = 0;
      this.targetX = 0;
      this.targetY = 0;
      this.ease = 0.15;
      this.animationFrame = null;
      
      this.init();
    }

    init() {
      this.createCursor();
      this.startAnimation();
    }

    createCursor() {
      this.cursor = document.createElement('div');
      this.cursor.className = 'mt-stack-scroll-cursor';
      
      this.cursor.innerHTML = `
        <svg viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="30" cy="30" r="29" stroke="white" stroke-width="2"/>
        </svg>
      `;
      
      document.body.appendChild(this.cursor);
      
      // Mouse move event
      document.addEventListener('mousemove', (e) => this.updateCursorPosition(e));
    }

    startAnimation() {
      this.animate();
    }

    showCursor() {
      this.cursor.classList.add('active');
    }

    hideCursor() {
      this.cursor.classList.remove('active');
    }

    updateCursorPosition(e) {
      this.targetX = e.clientX;
      this.targetY = e.clientY;
    }

    animate() {
      // Lerp animation for smooth following
      this.currentX += (this.targetX - this.currentX) * this.ease;
      this.currentY += (this.targetY - this.currentY) * this.ease;

      this.cursor.style.left = `${this.currentX}px`;
      this.cursor.style.top = `${this.currentY}px`;

      this.animationFrame = requestAnimationFrame(() => this.animate());
    }
  }

  // Bind events for a section
  function bindSectionEvents(section) {
    if (!globalCursor) return;

    // Buttons
    const buttons = section.querySelectorAll('.mt-stack-scroll-button');
    buttons.forEach(btn => {
      btn.addEventListener('mouseenter', () => globalCursor.showCursor());
      btn.addEventListener('mouseleave', () => globalCursor.hideCursor());
    });
  }

  // Initialize cursor and bind events
  function initStackScrollCursors() {
    // Create global cursor instance only once
    if (!globalCursor) {
      globalCursor = new StackScrollCursor();
    }

    // Bind events for all sections
    const sections = document.querySelectorAll('.mt-stack-scroll-section');
    sections.forEach(section => {
      bindSectionEvents(section);
    });
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStackScrollCursors);
  } else {
    initStackScrollCursors();
  }

  // Handle Shopify theme editor
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target.querySelector('.mt-stack-scroll-section')) {
        const section = event.target.querySelector('.mt-stack-scroll-section');
        bindSectionEvents(section);
      }
    });
  }
})();
